module.exports = __webpack_public_path__ + "img/map.8034b91c.png";